import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { SlidingPanel, Tabs } from 'core/components';
import { UpdatedAtSubtitle } from 'core/elements';
import { ITab } from 'core/types';
import { IJob } from 'jobs/types';
import { Size } from 'theme/enums';

import { BaseInformation, Requirements } from './tabs';

interface IProps {
  job: IJob;
  isOpen: boolean;
  onClose: () => void;
}

export const JobDetailsDrawer = ({ job, isOpen, onClose }: IProps) => {
  const { t } = useTranslation();

  const tabs: ITab[] = useMemo(() => {
    return [
      {
        label: t('labelBaseInformation'),
        content: <BaseInformation job={job} />,
      },

      {
        label: t('labelRequirements'),
        content: <Requirements job={job} />,
      },
    ];
  }, [job, t]);

  return (
    <SlidingPanel
      isOpen={isOpen}
      onClosePanel={onClose}
      title={t('titleJobDetailsDrawer', { name: job.name })}
      subtitle={<UpdatedAtSubtitle updatedAt={job.updatedAt} />}
      size={Size.LG}
    >
      <Tabs tabs={tabs} ariaLabel="jobDetails" />
    </SlidingPanel>
  );
};
